<template>
  <svg :class="classes" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.5 1.49939L6.43867 15.8721C6.30592 16.0628 6.12974 16.2193 5.92465 16.3286C5.71956 16.4379 5.49143 16.4969 5.25907 16.5007C5.0267 16.5046 4.79675 16.4532 4.58816 16.3507C4.37957 16.2482 4.19832 16.0977 4.05933 15.9114L1.5 12.4994"
      stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
  </svg>
</template>
<script setup lang="ts">
defineProps<{
  classes: string
}>()
</script>
